import Clients from './Clients';

const ClientsPage = () => {
  return <Clients />;
};

export default ClientsPage;
